<template>
  <div>
    <div class="my-container">
      <h2>Upload Data to CancerSRT</h2>
      <div style="margin: 10px;text-align: left;padding: 10px">
        If you would like to share their data, please fill the form below with necessary information. We will add to CancerSRT. If you have any question, please <a href="https://faculty.bjtu.edu.cn/rjxy/9433.html">contact us.</a>
      </div>
    </div>
    <div class="my-container">
      <h2>Information Form</h2>
      <div class="my-div-center">
        <el-form ref="form" :model="form" label-width="150px" style="width: 50%;margin-top: 20px;color: black" size="mini">
          <el-form-item label="technique">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>Technique:</strong></span>
            </span>
            <el-input v-model="form.technique" placeholder="please input" />
          </el-form-item>
          <el-form-item label="PubMedID">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>PubMedID:</strong></span>
            </span>
            <el-input v-model="form.PubMedID" placeholder="please input" />
          </el-form-item>
          <el-form-item label="AccessionNO">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>AccessionNO:</strong></span>
            </span>
            <el-input v-model="form.AccessionNO" placeholder="please input" />
          </el-form-item>
          <el-form-item label="URL">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>URL:</strong></span>
            </span>
            <el-input v-model="form.URL" placeholder="please input" />
          </el-form-item>
          <el-form-item label="EmailAddress">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>EmailAddress:</strong></span>
            </span>
            <el-input v-model="form.EmailAddress" placeholder="please input" />
          </el-form-item>
          <el-form-item label="description">
            <span slot="label">
              <span style="color: black;font-size: 18px"><strong>Description:</strong></span>
            </span>
            <el-input type="textarea" v-model="form.description"></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button size="mini" type="info" round  @click="onSubmit">submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Upload",
  data() {
    return {
      form: {
        technique: '',
        PubMedID: '',
        AccessionNO: '',
        URL: '',
        EmailAddress: '',
        description: ''
      }
    }
  },
  methods: {
    onSubmit() {
      let _this = this
      _this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/upload',
          _this.form,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
      ).then(result=>{
        this.$message.success("send success")
        console.log(result)
      })
    }
  }
}
</script>

<style scoped>
</style>
